import React from "react";
import { CGE } from "../../../../common/components/CGE";

const NextStepInterrupcion = ({ props }) => {

    return (
        <>
            <CGE.FormsField
                horizontal={true}
                labelName="Fecha Ingreso"
                handleChange={({ target }) => props.setInputDateAdimission(target.value)}
                idFormElement="inputDateAdimission"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputDateAdimission}
            />
            <CGE.FormsField
                horizontal={true}
                labelName="Tipo de Reclamo"
                handleChange={({ target }) => props.setInputClaim(target.value)}
                idFormElement="inputClaim"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputClaim}
            />
            <CGE.FormsField
                horizontal={true}
                labelName="Estado"
                handleChange={({ target }) => props.setInputCondition(target.value)}
                idFormElement="inputCondition"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputCondition}
            />
            <CGE.FormsField
                horizontal={true}
                labelName="Motivo Falla"
                handleChange={({ target }) => props.setInputFailureReason(target.value)}
                idFormElement="inputFailureReason"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputFailureReason}
            />
            <CGE.FormsField
                horizontal={true}
                labelName="Fecha/Hora estimada reposición"
                handleChange={({ target }) => props.setInputDataTimeReplacement(target.value)}
                idFormElement="inputDataTimeReplacement"
                typeFormElement="text"
                typeElement={'input'}
                readOnly={true}
                value={props.inputDataTimeReplacement}
            />
        </>
    );
};

export default NextStepInterrupcion;